// Hook CDC para registrar componentes Vue globais no app do dashboard.
// Chamado uma vez após `registerCdcLocale(i18n)` em
// `app/javascript/entrypoints/dashboard.js` (única edição upstream desta infra —
// ver `custom/EXTENSIONS.md`). Stub vazio em Phase 1; Phase 2 registra
// `WavoipTokenField`; Phase 3 adiciona `WavoipCallButton`; Phase 4 adiciona
// `WavoipCallWidget` (ADR 0007 WIDGET-01..08); Phase 6 adiciona
// `CardSearchButton` (ADR 0008); Phase 9 adiciona `CardSearchComboButton`
// (COMBO-01..09).
// Origem: ADR 0006.

import WavoipTokenField from './components/WavoipTokenField.vue';
import WavoipCallButton from './components/WavoipCallButton.vue';
import WavoipCallWidget from './components/WavoipCallWidget.vue';
import CardSearchButton from './components/CardSearchButton.vue';
import CardSearchComboButton from './components/CardSearchComboButton.vue';

export function registerCdcComponents(app) {
  // Guard contra colisão de nome (futuro sync upstream pode trazer componente
  // homônimo). Aplicado a todos os registros CDC (REGISTER-GUARD).
  if (!app.component('WavoipTokenField')) {
    app.component('WavoipTokenField', WavoipTokenField);
  }
  if (!app.component('WavoipCallButton')) {
    app.component('WavoipCallButton', WavoipCallButton);
  }
  if (!app.component('WavoipCallWidget')) {
    app.component('WavoipCallWidget', WavoipCallWidget);
  }
  if (!app.component('CardSearchButton')) {
    app.component('CardSearchButton', CardSearchButton);
  }
  if (!app.component('CardSearchComboButton')) {
    app.component('CardSearchComboButton', CardSearchComboButton);
  }
}
